BookingsCreateController.$inject = [
    '$scope',
    '$rootScope',
    'Club',
    'CONST',
    'Sports',
    '$uibModalInstance',
    'Time',
    '_',
    'deps',
    'alerts',
    '$timeout',
    'PlayersHistory',
    'BookingTypeMetadataEditModal',
    'moment',
    'User',
];

/* @ngInject */
function BookingsCreateController(
    $scope,
    $rootScope,
    Club,
    CONST,
    Sports,
    $uibModalInstance,
    Time,
    _,
    deps,
    alerts,
    $timeout,
    PlayersHistory,
    BookingTypeMetadataEditModal,
    moment,
    User,
) {
    var vm = this;
    vm.PlayerOffline = PlayerOffline;
    vm.title = 'Crear Turno';

    vm.loading = false;
    vm.types = CONST.bookings.types;

    vm.courtName = deps.court.name;

    var courtSports = deps.court.getSportsIds();
    vm.sports = Sports.collect(courtSports, true);

    vm.sport = _.first(vm.sports);
    vm.duration = vm.sport.data.default_duration;
    vm.duration_custom = vm.sport.data.default_duration;
    vm.discount = 0;
    vm.price = null;
    vm.balance = 0;
    vm.note = '';
    vm.end = null;
    vm.dow = undefined;
    vm.payment_type = 'cash';
    vm.phone_number_input = '';

    var date = deps.day.clone().startOf('day');
    var date_end = null;

    vm.country_id = Club.zone.country_id;
    vm.country_initial = getCountryInitial(vm.country_id);

    vm.min_end = deps.day.clone().add(7, 'days').toDate();

    vm.dateOptions = {
        initDate: vm.min_end,
        dateDisabled: false,
        formatYear: 'yy',
        minDate: vm.min_end,
        startingDay: 1,
        showWeeks: false,
    };

    vm.open1 = function () {
        vm.popup1.opened = true;
    };

    vm.popup1 = {
        opened: false,
    };

    vm.day = deps.day;
    if (deps.hour >= 24) {
        vm.day = Time.moment(deps.day).add(1, 'days');
    }

    var hour = new Time.Hour().fromFloat(deps.hour);
    date.add(hour.hour, 'hours').add(hour.min, 'minutes');

    vm.dayFormat = vm.day.format('ddd DD[/]MM');
    vm.hour = date.format('HH:mm');

    vm.player_loading = false;

    vm.dynamic_duration = {
        model: (function () {
            var d = new Time.Hour();
            d.hour = 0;
            d.min = 0;
            d.addMinutes(vm.sport.data.default_duration);
            return d.toDate();
        })(),
        changed: function () {
            var d = vm.dynamic_duration.model;
            vm.duration_custom = d.getHours() * 60 + d.getMinutes();
        },
        min: (function () {
            var d = new Date();
            d.setHours(0);
            d.setMinutes(30);
            return d;
        })(),
        max: (function () {
            var d = new Date();
            d.setHours(3);
            d.setMinutes(0);
            return d;
        })(),
    };

    // Actions
    vm.save = function () {
        updateMetadata();
    };
    vm.close = function () {
        $uibModalInstance.close(false);
    };
    vm.playerHistory = function (tab_owes) {
        if (vm.event.player.id) {
            PlayersHistory.open(vm.event.player, false, tab_owes);
        }
    };
    vm.showPlayers = function () {
        Club.openPlayersModal({
            onPhoneSelect: (phone) => {
                vm.event.player.phone = phone;
                const input = document.querySelector('#player_phone');
                const iti = intlTelInput.getInstance(input);
                iti.setNumber(phone);
            },
        });
    };

    vm.clearEndDate = function () {
        vm.create_booking_form.end.$setValidity('text', true);
        vm.create_booking_form.end.$setTouched('text', false);
        vm.end = null;
    };

    vm.endDateUpdated = function () {
        var selectedEndDate = vm.end ? moment(vm.end) : null;

        vm.end_text = {
            count: 0,
            last_date: '',
        };

        vm.create_booking_form.end.$setValidity('text', true);

        if (!selectedEndDate) {
            return;
        }

        let bookingDate = deps.day
            .clone()
            .set({ hour: 0, minute: 0, second: 0 });
        var tmp = deps.day.clone().set({ hour: 0, minute: 0, second: 0 });

        if (selectedEndDate.isBefore(bookingDate)) {
            vm.create_booking_form.end.$setValidity('text', false);
        }
        do {
            vm.end_text.count++;
            vm.end_text.last_date = tmp.format('DD-MM-YYYY');
            tmp.add(1, 'week');
            bookingDate = tmp.clone();
        } while (tmp.isSameOrBefore(selectedEndDate, 'date'));
        if (date.isSame(moment(), 'date') && date.isBefore(moment())) {
            vm.end_text.count--;
        }
    };

    vm.generatePlayerLink = function () {
        vm.loading = true;
        var data = {
            court_id: deps.court.id,
            datetime: date.format('Y-MM-DD HH:mm:ss'),
            player_id: vm.event.player.id,
            player_phone: vm.event.player.phone,
            sport_id: vm.sport.id,
            duration: vm.duration,
            price: vm.price,
            payment_type: vm.payment_type,
        };

        deps.court.api
            .all('track_link')
            .post(data)
            .then(function (res) {
                var link = res.link;
                window.open(link, '_blank');
            })
            .catch(function (res) {
                alerts.error(
                    '¡Error!',
                    'Verifique que seleccionó una fecha válida.',
                );
            })
            .finally(function () {
                vm.loading = false;
            });
    };

    vm.validateInput = function () {
        const input = document.querySelector('#player_phone');
        const iti = intlTelInput.getInstance(input);
        if (!input.value.trim()) {
            vm.event.player.phone = undefined;
            vm.create_booking_form.player_phone.$valid = false;
            vm.create_booking_form.player_phone.$invalid = true;
            return;
        }
        if (iti.isValidNumber()) {
            vm.event.player.phone = iti.getNumber();
            vm.create_booking_form.player_phone.$valid = true;
            vm.create_booking_form.player_phone.$invalid = false;
            return;
        }
        vm.event.player.phone = undefined;
        vm.create_booking_form.player_phone.$valid = false;
        vm.create_booking_form.player_phone.$invalid = true;
    };

    function activate() {
        vm.event = deps.event || eventDefault();
        updatePrice();
        $scope.$watchGroup(
            ['vm.discount', 'vm.duration', 'vm.dow'],
            updatePrice,
        );

        $scope.$watchGroup(
            [
                'vm.event.player.phone',
                'vm.create_booking_form.player_phone.$valid',
            ],
            function () {
                var valid = vm.create_booking_form.player_phone.$valid;

                vm.event.player.id = null;
                if (!valid || !vm.event.player.phone) {
                    return;
                }

                vm.player_loading = true;
                Club.API.customGET('players', {
                    phone: vm.event.player.phone,
                })
                    .then(function (player) {
                        vm.event.player.name = player.name;
                        vm.event.player.id = player.id;
                        vm.event.player.owes_count = player.owes_count;
                        vm.event.player.no_wine = player.no_wine;
                        if (player.email) {
                            vm.event.player.email = player.email;
                        }
                    })
                    .catch(angular.noop)
                    .finally(function () {
                        vm.player_loading = false;
                    });
            },
        );

        Club.API.customGET('calendar/dow', {
            date: date.format('Y-MM-DD'),
        }).then(function (res) {
            vm.dow = res.dow;
        });

        // Focus fix
        $timeout(function () {
            angular.element('input.aside-focus').focus();
        }, 200);
    }

    function eventDefault() {
        return {
            sport_id: vm.sport.id,
            duration: vm.duration,
            // datetime: date.format('Y-MM-DD HH:mm'),
            // datetime: deps.day.format('Y-MM-DD') + " " + vm.hour,
            datetime: vm.day.format('Y-MM-DD') + ' ' + vm.hour,

            // court_id
            player: {
                id: null,
                phone: undefined,
                name: '',
                email: null,
                owes_count: 0,
                no_wine: 0,
            },
            type: 'once',
            fixed: false,
            booking: {
                type: 0,
                since: null,
                end: null,
                deposit: null,
                payment_type: 'cash',
            },
        };
    }

    function updateMetadata() {
        const selectedType = vm.types.find(
            ({ id }) => vm.event.booking.type === id,
        );
        if (selectedType && selectedType.code == 'birthday') {
            delete selectedType.metadata.agreement;
            delete selectedType.metadata.invitations;
            return new Promise((resolve) => {
                BookingTypeMetadataEditModal.open(vm.event.booking, {
                    allowCancel: true,
                    onSave: function () {
                        alerts
                            .verifyCode(null, null, User)
                            .then((res) => {
                                save(res);
                                resolve();
                            })
                            .catch((error) => {
                                alerts.errorHandler(error);
                            });
                    },
                });
            });
        }

        alerts
            .verifyCode(null, null, User)
            .then((res) => {
                save(res);
            })
            .catch((error) => {
                alerts.errorHandler(error);
            });
    }

    function save({ code }) {
        var data = formatData(code);

        vm.loading = true;
        deps.court.api
            .all('bookings')
            .post(data)
            .then(function (newBooking) {
                alerts.success('¡Exito!', 'Se creó el evento correctamente');
                $uibModalInstance.close(true);
                localStorage.setItem(
                    'lastAction',
                    JSON.stringify({
                        tabId: $rootScope.tabId,
                        ts: Date.now(),
                    }),
                );
                deps.update(newBooking, deps.court);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

    function formatData(code) {
        var data = _.merge(
            {
                code: code,
            },
            vm.event,
        );

        data.duration = !vm.event.booking.type
            ? vm.duration
            : vm.duration_custom;
        data.sport_id = vm.sport.id;

        if (vm.note.length) {
            data.note = vm.note;
        }

        data.booking.deposit = data.booking.deposit || 0;

        if (data.fixed) {
            var since = deps.day.clone();

            data.booking.since = since.format('Y-MM-DD');

            data.booking.end = vm.end ? moment(vm.end).format('Y-MM-DD') : null;
        } else {
            delete data.booking.since;
            delete data.booking.end;
        }

        return data;
    }

    var updatePrice = _.debounce(function () {
        $timeout(function () {
            var hour = deps.hour,
                duration = vm.duration,
                dow = vm.dow;

            vm.price =
                dow === undefined
                    ? null
                    : deps.court.price(dow, hour, duration);
        });
    }, 500);

    function getCountryInitial(country_id) {
        // return "bo";
        switch (country_id) {
            case 1:
                return 'ar';
                break;
            case 2:
                return 'cl';
                break;
            case 3:
                return 'pa';
                break;
            case 4:
                return 'pe';
                break;
            case 5:
                return 'bo';
                break;
            case 6:
                return 'ec';
                break;
            case 7:
                return 've';
                break;
            case 8:
                return 'us';
                break;
            case 9:
                return 'co';
                break;
            case 10:
                return 'mx';
                break;
            case 11:
                return 'uy';
                break;
            case 12:
                return 'cr';
                break;
            default:
                return 'ar';
                break;
        }
    }

    vm.getSuggestions = function (params) {
        vm.searchingUsers = true;
        return Club.API.customGET('players_offline', { search: params })
            .then(function (data) {
                vm.searchingUsers = false;
                return data.map(function (item) {
                    return new PlayerOffline(item);
                });
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                vm.searchingUsers = false;
            });
    };

    $scope.ngModelOptionsSelected = function (player) {
        // autocompleto player con datos del suggestion
        addPlayer(player);
    };

    function PlayerOffline(data) {
        this.id = 0;
        this.loaded = false;
        this.name = null;
        this.phone = null;
        this.email = null;
        this.category = null;
        this.date_of_birth = null;
        this.gender = null;
        this.created_at = null;
        this.updated_at = null;
        this.sportClub = null;

        Object.assign(this, data);

        this.date_of_birth = this.date_of_birth
            ? Time.moment(this.date_of_birth)
            : null;

        this._date_of_birth = this.date_of_birth
            ? Time.moment(this.date_of_birth).format('DD/MM/YYYY')
            : null;

        this.suggestion = `${this.name} (${this.phone})`;
    }

    PlayerOffline.prototype.getId = function () {
        return this.id;
    };

    PlayerOffline.prototype.getDateOfBirth = function (format = null) {
        return this.date_of_birth
            ? Time.moment(this.date_of_birth).format(format)
            : null;
    };
    PlayerOffline.prototype.getCreatedAt = function () {
        return Time.moment(this.created_at);
    };
    PlayerOffline.prototype.getUpdatedAt = function () {
        return Time.moment(this.updated_at);
    };

    function addPlayer(player) {
        vm.event.player.name = player.name;
        vm.event.player.id = player.id;
        vm.event.player.phone = player.phone;
        vm.event.player.email = '';
        if (player.email) {
            vm.event.player.email = player.email;
        }
        const input = document.querySelector('#player_phone');
        const iti = intlTelInput.getInstance(input);
        iti.setNumber(player.phone);
    }

    vm.addNewPlayer = function () {
        vm.event.player.id = '';
        vm.event.player.phone = '';
        vm.event.player.email = '';
        vm.noResults = null;
        angular.element('#player_phone').focus();
    };

    activate();
}

export default BookingsCreateController;
